(function () {
  'use strict';

  if (document.documentElement.getAttribute('data-template') !== 'article') return;

  var EVENT_PREFIX = 'karmashop:';
  var eventQueue = [];
  var readyTimer = null;
  var readyAttempts = 0;

  function clean(value, maxLength) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, maxLength || 100);
  }

  function articleData() {
    var heading = document.querySelector('#MainContent h1');
    return {
      article_path: clean(window.location.pathname, 200),
      article_title: clean(heading ? heading.textContent : document.title, 150)
    };
  }

  function publishNow(item) {
    if (
      !window.Shopify ||
      !Shopify.analytics ||
      typeof Shopify.analytics.publish !== 'function'
    ) {
      return false;
    }

    try {
      var result = Shopify.analytics.publish(EVENT_PREFIX + item.name, item.data);
      if (result && typeof result.catch === 'function') result.catch(function () {});
      return true;
    } catch (error) {
      return false;
    }
  }

  function flushQueue() {
    if (!eventQueue.length) return;
    var remaining = [];

    for (var i = 0; i < eventQueue.length; i++) {
      if (!publishNow(eventQueue[i])) remaining.push(eventQueue[i]);
    }

    eventQueue = remaining;
    if (!eventQueue.length && readyTimer) {
      window.clearInterval(readyTimer);
      readyTimer = null;
    }
  }

  function startReadyCheck() {
    if (readyTimer) return;
    readyTimer = window.setInterval(function () {
      readyAttempts += 1;
      flushQueue();
      if (!eventQueue.length || readyAttempts >= 40) {
        window.clearInterval(readyTimer);
        readyTimer = null;
      }
    }, 250);
  }

  function publish(name, details) {
    var payload = articleData();
    var key;

    for (key in details) {
      if (Object.prototype.hasOwnProperty.call(details, key)) payload[key] = details[key];
    }

    var item = { name: name, data: payload };
    if (!publishNow(item)) {
      eventQueue.push(item);
      startReadyCheck();
    }
  }

  function widgetName(element) {
    if (!element) return 'inline_product_link';
    if (element.id === 'ks-chinese-zodiac-calculator') return 'zodiac_calculator';
    if (element.id === 'ks-zodiac-products') return 'zodiac_amulets';
    if (element.id === 'ks-chinese-zodiac-result') return 'zodiac_result';
    if (element.hasAttribute('data-karma-product-widget')) return 'horoscope_zodiac_set';
    if (element.hasAttribute('data-product-widget')) {
      return clean(element.getAttribute('data-product-widget'), 80) || 'recommended_products';
    }
    return 'inline_product_link';
  }

  function closestWidget(element) {
    return element.closest(
      '[data-karma-product-widget], [data-product-widget], #ks-zodiac-products, #ks-chinese-zodiac-calculator, #ks-chinese-zodiac-result'
    );
  }

  function productHandle(link) {
    try {
      var url = new URL(link.href, window.location.origin);
      var match = url.pathname.match(/^\/products\/([^/?#]+)/i);
      return match ? clean(decodeURIComponent(match[1]), 100) : '';
    } catch (error) {
      return '';
    }
  }

  function zodiacFromLink(link) {
    var card = link.closest('[data-zodiac]');
    if (card) return clean(card.getAttribute('data-zodiac'), 40);

    var handle = productHandle(link);
    var match = handle.match(/^amuleta-zodia-(.+)$/i);
    return match ? clean(match[1], 40) : '';
  }

  function observeWidgets() {
    if (!('IntersectionObserver' in window)) return;

    var selector = [
      '[data-karma-product-widget]',
      '[data-product-widget]',
      '#ks-zodiac-products',
      '#ks-chinese-zodiac-calculator'
    ].join(',');
    var widgets = document.querySelectorAll(selector);
    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          publish('article_widget_view', {
            widget_name: widgetName(entries[i].target)
          });
          observer.unobserve(entries[i].target);
        }
      },
      { threshold: 0.25 }
    );

    for (var i = 0; i < widgets.length; i++) observer.observe(widgets[i]);
  }

  function trackProductClicks() {
    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!target || typeof target.closest !== 'function') return;

        var link = target.closest('#MainContent a[href*="/products/"]');
        if (!link) return;

        var handle = productHandle(link);
        if (!handle) return;

        var widget = closestWidget(link);
        var zodiac = zodiacFromLink(link);
        var data = {
          widget_name: widgetName(widget),
          product_handle: handle
        };
        if (zodiac) data.zodiac = zodiac;

        publish('article_product_click', data);

        if (
          link.closest('#ks-chinese-zodiac-result') &&
          /^amuleta-zodia-/i.test(handle)
        ) {
          publish('zodiac_amulet_click', data);
        }
      },
      true
    );
  }

  function trackZodiacCalculator() {
    var form = document.getElementById('ks-chinese-zodiac-form');
    if (!form) return;

    form.addEventListener('submit', function () {
      var year = document.getElementById('ks-chinese-zodiac-year');
      var month = document.getElementById('ks-chinese-zodiac-month');
      var day = document.getElementById('ks-chinese-zodiac-day');
      if (!year || !month || !day || !year.value || !month.value || !day.value) return;

      publish('zodiac_calculator_submit', {
        widget_name: 'zodiac_calculator'
      });

      window.setTimeout(function () {
        var recommendation = document.querySelector(
          '#ks-chinese-zodiac-result a[href*="/products/amuleta-zodia-"]'
        );
        if (!recommendation) return;

        var zodiac = zodiacFromLink(recommendation);
        var data = { widget_name: 'zodiac_result' };
        if (zodiac) data.zodiac = zodiac;
        publish('zodiac_result_view', data);
      }, 50);
    });
  }

  function init() {
    observeWidgets();
    trackProductClicks();
    trackZodiacCalculator();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
